import { chakra, HTMLChakraProps, useColorModeValue } from "@chakra-ui/react";

export const Logo = (props: HTMLChakraProps<"img">) => {
  const logoURL = useColorModeValue("/acs-logo.png", "/acs-logo-dark.png");
  return <chakra.img height="8" src={logoURL} {...props} />;
};
